<template>
  <div class="p-5 b-fs">
    <a :href="link" target="_blank" class="unt crd e-4 h:e-8 rlt -o-h -r-4 w-15 10/16 scale-down-on-hover">
      <div class="w-f h-f b-cl abs .t .s c-s -r-i">
        <div class="h-f w-f rlt -r-i">
          <img
            :src="photo"
            class="abs .f -obj-cv -r-i"
          />
          <!-- <div class="abs .f -g-b -r-i"></div> -->
        </div>
        <div class="w-f p-6 c-20-t">
          <div class="o-5">CATEGORY</div>
          <div style="font-size: 24px; font-weight: bold" class="o-9 CASE">
            — {{ name }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'cateCardWidget',
  props: {
    link: String,
    photo: String,
    name: String
  }
}
</script>
